import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import { store } from '@/stores';

const NAME = '%%NAME%%';
const EMAIL = '%%EMAIL%%';

const userStore = getModule(UserStore, store);

export const CmsVariableResolver = {
  resolve(content: string): string {
    const user = userStore.currentUser;
    if (user) {
      return content.replace(NAME, user.firstname + ' ' + user.lastname).replace(EMAIL, user.email);
    } else {
      return content;
    }
  },
};
